import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { getCrmGeography } from "../../api";
import { useAnalyticsFetch } from "./hooks/useAnalyticsFetch";
import BarChartCard from "./components/BarChartCard";

const GROUP_BY_OPTIONS = [
  { value: "country", label: "Country" },
  { value: "state", label: "State" },
  { value: "city", label: "City" },
];

const Geography = ({ filter, startDate, endDate }) => {
  const [groupBy, setGroupBy] = useState("country");
  const [country, setCountry] = useState("");

  const enabled = groupBy !== "city" || Boolean(country);

  const { data, loading } = useAnalyticsFetch(
    getCrmGeography,
    [filter, startDate, endDate, groupBy, groupBy === "city" ? country : undefined],
    enabled,
  );

  return (
    <Container sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}>
      <Box sx={{ display: "flex", gap: "1rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="geography-groupby-label">Group By</InputLabel>
          <Select
            labelId="geography-groupby-label"
            label="Group By"
            value={groupBy}
            onChange={(event) => setGroupBy(event.target.value)}
          >
            {GROUP_BY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {groupBy === "city" && (
          <TextField
            size="small"
            label="Country (required)"
            value={country}
            onChange={(event) => setCountry(event.target.value)}
            placeholder="e.g. AU"
          />
        )}
      </Box>
      <BarChartCard
        title={`Revenue by ${GROUP_BY_OPTIONS.find((option) => option.value === groupBy)?.label}`}
        labels={data?.chart?.labels || []}
        series={data?.chart?.series || []}
        label="Revenue"
        loading={loading}
        currency
      />
    </Container>
  );
};

Geography.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Geography;
